import { authFetchJson } from '../api';
import type { UserProgression } from '@shared/progression';

/**
 * Fetch the signed-in user's per-map stars/cups + pre-summed totals.
 * Returns an empty progression for new accounts (server returns
 * `{ perMap: [], totals: { stars: 0, cups: 0 } }`).
 */
export async function fetchUserProgression(): Promise<UserProgression> {
  return authFetchJson<UserProgression>(`/api/me/progression`);
}
